import { call, select, put, takeLatest, all, take } from "redux-saga/effects";
import {
  FETCH_WALLET_DETAILS_START,
  FETCH_SINGLE_WALLET_VIEW_START,
  FETCH_ALL_TRANSACTION_START,
  PAYMENT_GATEWAY_SERVICES_START,
  PAYMENT_GATEWAY_REQUEST_START,
  PAYMENT_GATEWAY_VIEW_START,
  PAYMENT_GATEWAY_GENERATE_START,
} from "../actions/ActionConstant";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/ToastNotification";
import api from "../../components/Environment";
import { getCommonSaga } from "../sagaUtils";
import store from "..";
import { paymentGatewayGenerateFailure, paymentGatewayGenerateSuccess, paymentGatewayRequestFailure, paymentGatewayRequestSuccess, paymentGatewayServicesFailure, paymentGatewayServicesSuccess, paymentGatewayViewFailure, paymentGatewayViewSuccess } from "../actions/PaymentGatewayAction";

// function* cancelWithDrawRequestAPI(action) {
//   let withDrawalsData = yield select((state) => state.wallet.withDrawals.data);
//   const walletData = yield select(state => state.wallet.singleWallet.data);
//   try {
//     const response = yield api.postMethod("user_withdrawals/cancel", action.data);

//     if (response.data.success) {
//       yield put(cancelWithDrawRequestSuccess(response.data.data));
//       yield call(getSuccessNotificationMessage, response.data.message);
//       if (Object.keys(walletData).length > 0){
//         store.dispatch(fetchSingleWalletViewSuccess({
//           ...walletData,
//           user_wallet: response.data.data.user_wallet,
//         }));
//       }
//       if (Object.keys(withDrawalsData).length > 0)
//         yield put(fetchWithDrawalsSuccess({
//           ...withDrawalsData,
//           user_withdrawals: withDrawalsData.user_withdrawals.map((account) =>
//             account.id === action.data.user_withdrawal_id ?
//               response.data.data.user_withdrawal
//               : account
//           ),
//         }));
//     }
//     else {
//       yield put(cancelWithDrawRequestFailure(response.data.error));
//       yield call(getErrorNotificationMessage, response.data.error);
//     }
//   } catch (error) {
//     yield put(cancelWithDrawRequestFailure(error));
//     yield call(getErrorNotificationMessage, error.message);
//   }
// }

// function* walletPaymentViewAPI(action) {
//   yield getCommonSaga({
//     apiUrl: "wallet_payments/view",
//     payload: action.data,
//     successNotify: false, 
//     success: walletPaymentViewSuccess,
//     failure: walletPaymentViewFailure,
//   });
// }

function* paymentGatewayServicesAPI(action) {
  yield getCommonSaga({
    apiUrl: "payment_gateway_services",
    payload: action.data,
    successNotify: false, 
    success: paymentGatewayServicesSuccess,
    failure: paymentGatewayServicesFailure,
  });
}

function* paymentGatewayRequestAPI(action) {
  yield getCommonSaga({
    apiUrl: "payment_gateway_services/store",
    payload: action.data,
    successNotify: false, 
    success: paymentGatewayRequestSuccess,
    failure: paymentGatewayRequestFailure,
  });
}

function* paymentGatewayGenerateAPI(action) {
  yield getCommonSaga({
    apiUrl: "payment_gateway_services/generate_api_key",
    payload: action.data,
    successNotify: false, 
    success: paymentGatewayGenerateSuccess,
    failure: paymentGatewayGenerateFailure,
  });
}

function* paymentGatewayViewAPI(action) {
  yield getCommonSaga({
    apiUrl: "payment_gateway_services/get_api_key",
    payload: action.data,
    successNotify: false, 
    success: paymentGatewayViewSuccess,
    failure: paymentGatewayViewFailure,
  });
}

export default function* PaymentGatewaySaga() {
  yield all([
    yield takeLatest(PAYMENT_GATEWAY_SERVICES_START, paymentGatewayServicesAPI),
    yield takeLatest(PAYMENT_GATEWAY_REQUEST_START, paymentGatewayRequestAPI),
    yield takeLatest(PAYMENT_GATEWAY_VIEW_START, paymentGatewayViewAPI),
    yield takeLatest(PAYMENT_GATEWAY_GENERATE_START, paymentGatewayGenerateAPI),
  ])
}